import { render, staticRenderFns } from "./FCFaqCard.vue?vue&type=template&id=482cd31c&scoped=true&"
import script from "./FCFaqCard.vue?vue&type=script&lang=ts&"
export * from "./FCFaqCard.vue?vue&type=script&lang=ts&"
import style0 from "./FCFaqCard.vue?vue&type=style&index=0&id=482cd31c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cd31c",
  null
  
)

export default component.exports